import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { Layout } from './components/Layout';
import { ProfilePage } from './pages/ProfilePage';
import { MailboxesPage } from './pages/MailboxesPage';
import { MailboxDetailPage } from './pages/MailboxDetailPage';
import { MessageDetailPage } from './pages/MessageDetailPage';
import { ForwardingPage } from './pages/ForwardingPage';
import { SubscriptionSelectPage } from './pages/SubscriptionSelectPage';
import { SubscriptionCardPage } from './pages/SubscriptionCardPage';
import { NotFoundPage } from './pages/NotFoundPage';

const rootRoute = createRootRoute({
  component: Layout,
  notFoundComponent: NotFoundPage,
});

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: '/', component: MailboxesPage });
const meRoute = createRoute({ getParentRoute: () => rootRoute, path: '/me', component: ProfilePage });
const forwardingRoute = createRoute({ getParentRoute: () => rootRoute, path: '/forwarding', component: ForwardingPage });
/** Исход неудачного диплинка партнёра (Δ-«ж»); проставляется bff-ui при редиректе. */
export type DeeplinkOutcome = 'denied' | 'unavailable';

const mailboxPickerSearch = (search: Record<string, unknown>): { deeplink?: DeeplinkOutcome } =>
  search.deeplink === 'denied' || search.deeplink === 'unavailable'
    ? { deeplink: search.deeplink }
    : {};

const mailboxPickerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/mailboxes/',
  component: SubscriptionSelectPage,
  validateSearch: mailboxPickerSearch,
});

const subscriptionSelectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/subscriptions/select',
  component: SubscriptionSelectPage,
  validateSearch: mailboxPickerSearch,
});

const subscriptionCardSearch = (search: Record<string, unknown>): { rename?: boolean } =>
  search.rename === true || search.rename === '1' || search.rename === 1
    ? { rename: true }
    : {};

const subscriptionCardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/subscriptions/$subscriptionId',
  component: SubscriptionCardPage,
  validateSearch: subscriptionCardSearch,
});

const mailboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/mailbox/$mailboxId',
  component: MailboxDetailPage,
});
const messageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/mailbox/$mailboxId/message/$messageId',
  component: MessageDetailPage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  meRoute,
  forwardingRoute,
  mailboxPickerRoute,
  subscriptionSelectRoute,
  subscriptionCardRoute,
  mailboxRoute,
  messageRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
